import { render, staticRenderFns } from "./base-table-ce.vue?vue&type=template&id=4c4b79d0&scoped=true"
import script from "./base-table-ce.vue?vue&type=script&lang=ts"
export * from "./base-table-ce.vue?vue&type=script&lang=ts"
import style0 from "./base-table-ce.vue?vue&type=style&index=0&id=4c4b79d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b79d0",
  null
  
)

export default component.exports